import { defineComponent as u, useCssModule as g, computed as l, ref as w, watch as b, createElementBlock as h, openBlock as m, renderSlot as v, withDirectives as _, createElementVNode as r, normalizeStyle as x, normalizeClass as c, unref as i, toDisplayString as y, vShow as k } from "vue";
import { _ as B } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const D = {
  class: "stash-badge tw-relative tw-inline-block",
  "data-test": "stash-badge"
}, S = /* @__PURE__ */ u({
  name: "ll-badge",
  __name: "Badge",
  props: {
    animate: { type: Boolean, default: !1 },
    color: { default: "red" },
    content: { default: void 0 },
    isDisabled: { type: Boolean, default: !1 },
    max: { default: 99 },
    offset: { default: () => ({
      top: void 0,
      right: void 0
    }) },
    position: { default: "top-right" },
    showZero: { type: Boolean, default: !1 },
    variant: { default: "standard" }
  },
  setup(p) {
    const o = g(), t = p, s = l(() => {
      const e = parseInt(t.content, 10), a = parseInt(t.max, 10);
      return e != t.content || a != t.max ? t.content : e > a ? `${a}+` : e;
    }), d = (e) => e === 0 ? "0" : `${e}px`, f = l(() => ({
      top: t.offset.top !== void 0 ? d(t.offset.top) : void 0,
      right: t.offset.right !== void 0 ? d(t.offset.right) : void 0
    })), n = w(!1);
    return b(
      () => t.content,
      (e, a) => {
        t.animate && a !== e && (n.value = !0, setTimeout(() => {
          n.value = !1;
        }, 1e3));
      }
    ), (e, a) => (m(), h("span", D, [
      v(e.$slots, "default"),
      _(r("span", {
        "data-test": "stash-badge|content-wrapper",
        class: c([
          {
            [i(o)["top-right"]]: t.position === "top-right" && t.variant !== "dot",
            "tw-absolute": t.variant === "dot" || t.position === "top-right",
            "tw-ml-1.5": t.position === "inline"
          }
        ]),
        style: x(t.variant === "dot" || t.position === "top-right" ? f.value : "")
      }, [
        r("span", {
          "data-test": "stash-badge|content",
          class: c(["tw-inline-block tw-whitespace-nowrap tw-rounded-full tw-text-center tw-text-[10px] tw-font-semibold tw-leading-4 tw-text-white", [
            {
              "tw-animate-grow": n.value,
              "tw-bg-red-500": t.color === "red" && !t.isDisabled,
              "tw-bg-blue-500": t.color === "blue" && !t.isDisabled,
              "tw-absolute": t.variant === "dot",
              "tw-bg-ice-200 tw-text-white": t.isDisabled,
              [i(o)["badge-dot"]]: t.variant === "dot",
              [i(o)["badge-standard"]]: t.variant === "standard",
              "tw-px-1.5": t.variant !== "dot"
            }
          ]])
        }, y(t.variant === "dot" ? null : s.value), 3)
      ], 6), [
        [k, t.variant === "dot" || s.value || s.value === 0 && t.showZero]
      ])
    ]));
  }
}), C = {
  "badge-standard": "_badge-standard_hcbk5_2",
  "badge-dot": "_badge-dot_hcbk5_7",
  "top-right": "_top-right_hcbk5_14"
}, M = {
  $style: C
}, E = /* @__PURE__ */ B(S, [["__cssModules", M]]);
export {
  E as default
};
//# sourceMappingURL=Badge.js.map
